import { ACTIONS } from '../Actions/privacyPolicyActions';

const initialState = {
  privacyPolicy: {},
  toggle: false,
};

const privacyPolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_GROUP_PRIVACY_POLICY:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.ACCEPT_GROUP_PRIVACY_POLICY:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.TOGGLE_CHECK:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default privacyPolicyReducer;
